export const toFormUrlEncoded = (data: Record<string, string>): string => new URLSearchParams(data).toString();

export const extractQueryParam = (urlOrSearch: string, paramName: string): string | null => {
  const match = urlOrSearch.match(new RegExp(`[?&]${paramName}=([^&]+)`));
  return match ? decodeURIComponent(match[1]) : null;
};
